import React from "react";
import * as Styled from "./RollAdsModal.styled";
import { RollAdsModalHeader } from "./roll-ads-modal-header/RollAdsModalHeader";
import { RollAdsModalBody } from "./roll-ads-modal-body/RollAdsModalBody";
import { IRollAdsModalProps } from "../../../../libs/models/ad-server";

export const RollAdsModal: React.FC<IRollAdsModalProps> = ({ show, onClose, campaignId, isEdit = false, fetchCampaigns}) => {
  return (
    <Styled.ModalWrapper show={show} onHide={onClose} fullscreen centered>
      <RollAdsModalHeader onClose={onClose} />
      <RollAdsModalBody campaignId={campaignId} isEdit={isEdit} onClose={onClose} fetchCampaigns={fetchCampaigns} />
    </Styled.ModalWrapper>
  );
};
